var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilesSelec({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-plus 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 2.53418H6.5C5.96957 2.53418 5.46086 2.74489 5.08579 3.11997C4.71071 3.49504 4.5 4.00375 4.5 4.53418V20.5342C4.5 21.0646 4.71071 21.5733 5.08579 21.9484C5.46086 22.3235 5.96957 22.5342 6.5 22.5342H18.5C19.0304 22.5342 19.5391 22.3235 19.9142 21.9484C20.2893 21.5733 20.5 21.0646 20.5 20.5342V8.53418L14.5 2.53418Z",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5 2.53418V8.53418H20.5",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 18.5342V12.5342",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.5 15.5342H15.5",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesSelec);
export default __webpack_public_path__ + "static/media/FilesSelec.7592b749a59b737e8e8a95ef5517db45.svg";
export { ForwardRef as ReactComponent };